import Vue from 'vue'
import XRHead from './usercenter/head/index'
import XRSearchHead from './usercenter/searchHead/index'
import XRPurchaseSearchHead from './usercenter/purchaseSearchHead/index'
import XREditHead from './usercenter/editHead/index'
import XRTop from './usercenter/top/index'
import XRtoast from './tools/index'
import XRResult from './result/index'
import VRefresh from './refresh/index'
import VRefreshScrollEvent from './refreshScrollEvent/index'
import XRSlide from './swiper/slideindex'
import XRSwiper from './swiper/swiperindex'

import XRsqSwiper from './sqswiper/sqswiperindex'

import XRdrawer from './drawer/index'

import XRMobileBuyNow from './index/mobile/buynow/index'
import XRMobileTodayNew1 from './index/mobile/todaynew1/index'
import XRMobileTodayNew2 from './index/mobile/todaynew2/index'
import XRMobilegroupShop from './index/mobile/groupShop/index'
import XRMobileYouPin1 from './index/mobile/youpin1/index'
import XRMobileYouPin from './index/mobile/youpin/index'
import XRMobileYouPin2 from './index/mobile/youpin2/index'
import XRMobileAd1 from './index/mobile/ad1/index'
import XRMobileAd2 from './index/mobile/ad2/index'
import XRMobileAd3 from './index/mobile/ad3/index'
import XRMobileAd4 from './index/mobile/ad4/index'
import XRMobileShopAd1 from './index/mobile/shopad1/index'
import XRMobileShopAd2 from './index/mobile/shopad2/index'
import XRMobileAdImg1 from './index/mobile/adImg1/index'


import VPageTip from './pageTip/index'
import XRsign from './signin/index'
import XRbottom from './bottom/index'

import VRLoadMore from './loadmore/index'

const install = function(Vue) {
  Vue.component(XRHead.name, XRHead)
  Vue.component(XRSearchHead.name, XRSearchHead)
  Vue.component(XRPurchaseSearchHead.name, XRPurchaseSearchHead)
  Vue.component(XREditHead.name, XREditHead)
  Vue.component(XRtoast.name, XRtoast)
  Vue.component(XRTop.name, XRTop)
  Vue.component(XRResult.name, XRResult)
  Vue.component(VRefresh.name, VRefresh)
  Vue.component(VRefreshScrollEvent.name, VRefreshScrollEvent)
  Vue.component(XRSlide.name, XRSlide)
  Vue.component(XRSwiper.name, XRSwiper)

  Vue.component(XRsqSwiper.name, XRsqSwiper)

  Vue.component(XRMobileBuyNow.name, XRMobileBuyNow)
  Vue.component(XRMobileTodayNew1.name, XRMobileTodayNew1)
  Vue.component(XRMobileTodayNew2.name, XRMobileTodayNew2)
  Vue.component(XRMobilegroupShop.name, XRMobilegroupShop)
  Vue.component(XRMobileYouPin1.name, XRMobileYouPin1)
  Vue.component(XRMobileYouPin2.name, XRMobileYouPin2)
  Vue.component(XRMobileYouPin.name, XRMobileYouPin)
  Vue.component(XRMobileAd1.name, XRMobileAd1)
  Vue.component(XRMobileAd2.name, XRMobileAd2)
  Vue.component(XRMobileAd3.name, XRMobileAd3)
  Vue.component(XRMobileAd4.name, XRMobileAd4)
  Vue.component(XRMobileShopAd1.name, XRMobileShopAd1)
  Vue.component(XRMobileShopAd2.name, XRMobileShopAd2)
  Vue.component(XRMobileAdImg1.name, XRMobileAdImg1)

  Vue.component(XRsign.name, XRsign)
  Vue.component(XRbottom.name, XRbottom)
  Vue.component(VPageTip.name, VPageTip)

  Vue.component(XRdrawer.name, XRdrawer)

  Vue.component(VRLoadMore.name, VRLoadMore)
}
export default install


// WEBPACK FOOTER //
// ./src/components/index.js